/* el-experts.js — sections/el-experts.liquid
   Read More / Read Less: shows the rest of an expert's bio in place. */
(function () {
  'use strict';
  if (window.elExpertsReady) return;
  window.elExpertsReady = true;

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-el-expert-toggle]');
    if (!button) return;
    var panel = document.getElementById(button.getAttribute('aria-controls'));
    if (!panel) return;
    var open = button.getAttribute('aria-expanded') !== 'true';
    panel.hidden = !open;
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    button.textContent = open ? button.getAttribute('data-less') : button.getAttribute('data-more');
  });
})();
